import theme from 'helpers/theme';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  p: {
    fontSize: '16px',
    lineHeight: '1.5',
    color: theme.colors.primaryBlack
  },
  heading: {
    color: theme.colors.primaryBlack,
    fontSize: 19,
    fontWeight: 800,
    padding: 0,
    margin: '0px 0px 4px 0px'
  },
  secondaryText: {
    color: theme.colors.textGrey,
    fontSize: 14,
    lineHeight: 1.3,
    margin: '4px 0px',
    padding: 0
  },
  secondaryTitle: {
    color: theme.colors.primaryBlack,
    fontSize: 14,
    fontWeight: 700,
    padding: 0,
    margin: '0px 0px 4px 0px'
  },
  errorText: {
    color: '#EB3F36',
    fontSize: 14,
    lineHeight: 1.3,
    margin: '8px 0px',
    padding: 0
  }
});

const Heading: React.FC = ({ children }) => {
  const classes = useStyles();
  return <h1 className={classes.heading}>{children}</h1>;
};

const Paragraph: React.FC = ({ children }) => {
  const classes = useStyles();
  return <p className={classes.p}>{children}</p>;
};

const SecondaryTitle: React.FC<React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>> = (props) => {
  const classes = useStyles();
  return (
    <p className={classes.secondaryTitle} {...props}>
      {props.children}
    </p>
  );
};

const SecondaryText: React.FC<React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>> = (props) => {
  const classes = useStyles();
  return (
    <p className={classes.secondaryText} {...props}>
      {props.children}
    </p>
  );
};

const ErrorText: React.FC<React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>> = (props) => {
  const classes = useStyles();
  return (
    <p className={classes.errorText} {...props}>
      {props.children}
    </p>
  );
};

export { SecondaryText, Heading, Paragraph, SecondaryTitle, ErrorText };
